// extracted by mini-css-extract-plugin
export default {"loader":"MainPreloader_loader__5fUfW","loaderInner":"MainPreloader_loaderInner__kZKXF","lol":"MainPreloader_lol__sdwj2"};